export default __webpack_public_path__ + "static/media/star.0d190bd5.svg";